import { Reducer } from 'redux';
import { ShippingState, ShippingTypes } from './types';

const INITIAL_STATE: ShippingState = {
  data: [],
  total: 0,
  hasError: false,
  isLoading: true,
};

const shippingListReducer: Reducer<ShippingState> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case ShippingTypes.LOAD_SHIPPING_LIST_REQUEST:
      return { ...state, isLoading: true };
    case ShippingTypes.LOAD_SHIPPING_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        hasError: false,
        page: action.payload.page,
        total: action.payload.total,
        data: action.payload.data,
      };
    case ShippingTypes.LOAD_FAILURE:
      return { ...state, isLoading: false, hasError: true, data: [], total: 0 };
    default:
      return state;
  }
};

export default shippingListReducer;
